import {Assistant} from './Assistant';
export default Assistant;
